export default "__VITE_ASSET__f4911efb__"